<template>
  <div class="single top-up-type">
    <b-row class="headline topup-text-single-summary">
      <b-col sm="" md="" class="txtHeader">
        <slot name="txtHeader">Direktaufladung</slot>
      </b-col>
      <b-col sm="" md="" class="change-link" v-if="changeBtn">
          <a @click.prevent="goToTopUpStep()" class="linkChange">ändern</a>
      </b-col>
    </b-row>
    <b-row class="top-up-content">
      <b-col sm="" md="" class="label">
        <slot name="txtTopUpAmount">Aufladebetrag:</slot>
      </b-col>
      <b-col sm="" md="" class="value">
        {{ price(topUpInfo) }}
      </b-col>
    </b-row>
      <b-row class="desc">
        <b-col sm="" md="" class="txtDesc">
          <slot name="txtDesc">
            <p>
              Die Direktaufladung erfolgt automatisch über die angegebenen Zahldaten nach Freischaltung Deiner SIM-Karte.
            </p>
          </slot>
        </b-col>
      </b-row>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { stepName as topUpStep } from '../TopUp/EnterTopUpAndPayment.vue'
import price from '@/mixins/price'

export default {
  name: 'ShowSingle',
  props: {
    topUpInfo: {
      type: Number
    },
    changeBtn: {
      default: true
    }
  },
  computed: {},
  methods: {
    goToTopUpStep: function () {
      this.goToStep(topUpStep)
    },
    ...mapMutations('activation', [
      'goToStep'
    ])
  },
  mixins: [
    price
  ]
}
</script>
